import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useGetPayableInvoicesSuspense = ({ ownerIds }: { ownerIds: string[] }) =>
    useRepositorySuspenseQuery('invoices', 'getAll', {
        ownerIds,
        isPayable: true,
    });
